export default "__VITE_ASSET__CPJOYGCu__"